import { render, staticRenderFns } from "./WaybillimportDetail.vue?vue&type=template&id=5fde3e1e&scoped=true&"
import script from "./WaybillimportDetail.vue?vue&type=script&lang=js&"
export * from "./WaybillimportDetail.vue?vue&type=script&lang=js&"
import style0 from "./WaybillimportDetail.vue?vue&type=style&index=0&id=5fde3e1e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fde3e1e",
  null
  
)

export default component.exports